import axios from "@/axios.js"

export default {
    fetch({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/customer/transaction")
                .then((response) => {
                    commit('SET_LIST', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}
